import { createApp }        from 'vue';
import App                  from './app.vue';
import { createI18n } from 'vue-i18n'
import axios from 'axios';
import './registerServiceWorker';
import router               from './router';
import store                from './store';
import { key }              from './store/util';
import { TroisJSVuePlugin } from 'troisjs';


// Importing the global css file
import '@/assets/style.scss';

import { Button, Carousel, Checkbox, Drawer, Input,InputNumber , Steps, Switch, Modal, Form, Menu, Dropdown, Pagination } from 'ant-design-vue';

(async () => {

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const locale = urlParams.get('lg')

    const messagesHr =  await axios.get(`/api/v3/system/translation/export/i18next?serviceKey=form--quote&x-client-key=oblak&language=hr-HR`).then((res) => {
        return res.data
    })
    const messagesSl =  await axios.get(`/api/v3/system/translation/export/i18next?serviceKey=form--quote&x-client-key=oblak&language=sl-SI`).then((res) => {
        return res.data
    })

    Object.keys(messagesSl).forEach(x => {
        if(messagesSl[x] === ""){
            messagesSl[x] = x;
        }
    });

    Object.keys(messagesHr).forEach(x => {
        if(messagesHr[x] === ""){
            messagesHr[x] = x;
        }
    });


    const i18n = createI18n({
        locale,
        fallbackLocale: 'sl-SI',
        messages: {
            'hr-HR': messagesHr,
            'sl-SI': messagesSl
        }
    })

    createApp(App)
        .use(store, key)
        .use(router)
        .use(TroisJSVuePlugin)
        .use(Steps)
        .use(Drawer)
        .use(Button)
        .use(Input)
        .use(InputNumber)
        .use(Carousel)
        .use(Checkbox)
        .use(Switch)
        .use(Modal)
        .use(Form)
        .use(Menu)
        .use(Dropdown)
        .use(Pagination)
        .use(i18n)
        .mount('#app');

})();
